import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalizationService {
  private readonly localeMap: Record<string, string> = {
    EN_US: 'en-US',
    RU_RU: 'ru-RU',
    AR_EG: 'ar-EG'
  };

  getLocaleFromEnum(localeEnum: string): string {
    return this.localeMap[localeEnum];
  }

  localizeNumber(value: number): string {
    const locale = this.loadLocalization();
    const isArabic = locale?.startsWith('ar');

    return new Intl.NumberFormat(isArabic ? 'ar' : locale, {
      maximumFractionDigits: 0,
    }).format(value);
  }

  saveLocalization(locale: string) {
    localStorage.setItem('selectedLanguage', locale);
  }

  loadLocalization(): string {
    return localStorage.getItem('selectedLanguage');
  }

  redirectToLocale(locale: string, page: string) {
    const isLocal = window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1';
    if (!isLocal) {
      window.location.href = `${window.location.origin}/${locale}/${page}`;
    }
  }

  applicationRedirect(page: string) {
    const currentLocale = window.location.pathname.split('/')[1];
    const locale = this.loadLocalization();
    if (locale && locale !== currentLocale) {
      this.redirectToLocale(locale, page);
    }
  }
}